export default "__VITE_ASSET__BuSLdHVK__"